(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-top-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf-dynamic-offer')) {
    class BfDynamicOffer extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.badge = this.querySelector('[data-bf-discount]');
        this.offer = this.querySelector('[data-bf-offer]');
        this.variantData = this.querySelector('[data-bf-variants]');
        this.section = this.closest('.bf-strip');

        if (!this.badge || !this.offer || !this.variantData) return;

        try {
          const variants = JSON.parse(this.variantData.textContent);
          this.variantMap = new Map(
            variants.map(({ id, price, estimatedRetailPrice }) => [
              String(id),
              { price: Number(price), retailPrice: Number(estimatedRetailPrice) }
            ])
          );
        } catch (error) {
          return;
        }

        if (!this.variantMap.size) return;

        this.initialized = true;
        this.handleChange = this.handleChange.bind(this);
        this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
        document.addEventListener('change', this.handleChange);
        document.addEventListener('variant:update', this.handleVariantUpdate);
        this.updateDiscount(this.dataset.variantId);
      }

      updateDiscount(variantId) {
        const id = String(variantId || '');
        if (!id || id === this.dataset.variantId) return;

        const variant = this.variantMap.get(id);
        if (!variant) return;

        const { price, retailPrice } = variant;
        const valid = Number.isFinite(price) &&
          Number.isFinite(retailPrice) &&
          retailPrice > price &&
          retailPrice > 0;

        if (!valid) {
          this.offer.hidden = true;
          this.dataset.variantId = id;
          this.updateAriaLabel('');
          return;
        }

        const discount = Math.round(((retailPrice - price) / retailPrice) * 100);
        if (discount <= 0) {
          this.offer.hidden = true;
          this.dataset.variantId = id;
          this.updateAriaLabel('');
          return;
        }

        this.badge.textContent = `${discount}% Off`;
        this.offer.hidden = false;
        this.dataset.variantId = id;
        this.updateAriaLabel(`${this.dataset.offerPrefix || ''} ${discount}% Off`);
      }

      updateAriaLabel(offerText) {
        if (!this.section) return;

        const base = `${this.dataset.sectionTitle || ''} ${this.dataset.liveText || ''}`.trim();
        this.section.setAttribute('aria-label', offerText ? `${base}, ${offerText}` : base);
      }

      handleChange(event) {
        const target = event.target;
        if (!target || target.name !== 'id') return;
        if (target.type === 'radio' && !target.checked) return;

        const nextId = String(target.value || '');
        if (this.variantMap.has(nextId)) this.updateDiscount(nextId);
      }

      handleVariantUpdate(event) {
        const variantId = event.detail && event.detail.resource && event.detail.resource.id;
        if (variantId == null) return;

        const productId = event.detail.data && event.detail.data.productId;
        const sectionProductId = this.section && this.section.dataset.bfProductId;
        if (productId && sectionProductId && String(productId) !== String(sectionProductId)) return;

        const nextId = String(variantId);
        if (this.variantMap.has(nextId)) this.updateDiscount(nextId);
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        document.removeEventListener('change', this.handleChange);
        document.removeEventListener('variant:update', this.handleVariantUpdate);
        this.variantMap = null;
        this.initialized = false;
      }
    }

    customElements.define('bf-dynamic-offer', BfDynamicOffer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-heading"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.collection-heading__description-wrapper').forEach(function(wrapper) {
      var btn = wrapper.querySelector('.collection-heading__read-more-btn');
      var btnText = btn ? btn.querySelector('.collection-heading__read-more-text') : null;

      if (!btn || !btnText) return;

      var readMoreText = btn.getAttribute('data-read-more') || 'Read more';
      var readLessText = btn.getAttribute('data-read-less') || 'Read less';

      function toggle() {
        var expanded = wrapper.getAttribute('data-expanded') === 'true';
        var next = !expanded;
        wrapper.setAttribute('data-expanded', next);
        btn.setAttribute('aria-expanded', next);
        btnText.textContent = next ? readLessText : readMoreText;
      }

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        toggle();
      });

      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["four_hand-steps"] && !Shopify.designMode) return;
  try {
    

  window.addEventListener('load', function () {

    const slider = document.querySelector('.fhs-slider');
    const dotsWrap = document.querySelector('.fhs-slider-dots');

    if (!slider || !dotsWrap) return;

    const cards = slider.querySelectorAll('.fhs-card');

    if (!cards.length) return;

    dotsWrap.innerHTML = '';

    cards.forEach((card,index)=>{

      const dot = document.createElement('button');

      dot.className = 'fhs-dot';

      if(index === 0){
        dot.classList.add('active');
      }

      dot.addEventListener('click',()=>{

        card.scrollIntoView({
          behavior:'smooth',
          inline:'start'
        });

      });

      dotsWrap.appendChild(dot);

    });

    slider.addEventListener('scroll',()=>{

      const sliderCenter =
        slider.scrollLeft +
        slider.offsetWidth / 2;

      let activeIndex = 0;
      let closest = Infinity;

      cards.forEach((card,index)=>{

        const cardCenter =
          card.offsetLeft +
          card.offsetWidth / 2;

        const distance =
          Math.abs(sliderCenter - cardCenter);

        if(distance < closest){
          closest = distance;
          activeIndex = index;
        }

      });

      document
        .querySelectorAll('.fhs-dot')
        .forEach(dot=>dot.classList.remove('active'));

      document
        .querySelectorAll('.fhs-dot')
        [activeIndex]
        ?.classList.add('active');

    });

  });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glp-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const heroButton = document.querySelector('.glphero-btn');

    if (!heroButton) return;

    heroButton.addEventListener('mouseenter', function () {
      heroButton.style.transform = 'translateY(-2px)';
    });

    heroButton.addEventListener('mouseleave', function () {
      heroButton.style.transform = 'translateY(0)';
    });
  });

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gruns_four_hands"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initFourHands(root) {
    if (root.dataset.fhsv2Initialized === 'true') return;

    const slider = root.querySelector('.fhsv2-slider');
    const dotsWrap = root.querySelector('.fhsv2-slider-dots');

    if (!slider || !dotsWrap) return;

    const cards = Array.from(slider.querySelectorAll('.fhsv2-card'));

    if (cards.length < 2) {
      dotsWrap.hidden = true;
      root.dataset.fhsv2Initialized = 'true';
      return;
    }

    root.dataset.fhsv2Initialized = 'true';

    const dots = cards.map((card, index) => {
      const dot = document.createElement('button');

      dot.type = 'button';
      dot.className = 'fhsv2-dot';
      dot.setAttribute('aria-label', `Go to card ${index + 1}`);
      dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');

      if (index === 0) dot.classList.add('active');

      dot.addEventListener('click', () => {
        const sliderRect = slider.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();

        slider.scrollTo({
          left: slider.scrollLeft + cardRect.left - sliderRect.left,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth'
        });
      });

      dotsWrap.appendChild(dot);
      return dot;
    });

    let frameRequested = false;

    function updateActiveDot() {
      frameRequested = false;

      if (window.matchMedia('(min-width: 1025px)').matches) return;

      const sliderRect = slider.getBoundingClientRect();
      const sliderCenter = sliderRect.left + sliderRect.width / 2;

      let activeIndex = 0;
      let closestDistance = Infinity;

      cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;
        const distance = Math.abs(sliderCenter - cardCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;

        dot.classList.toggle('active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    slider.addEventListener('scroll', () => {
      if (frameRequested) return;

      frameRequested = true;
      window.requestAnimationFrame(updateActiveDot);
    }, { passive: true });

    window.addEventListener('resize', updateActiveDot, { passive: true });
    updateActiveDot();
  }

  function initAllFourHands() {
    document.querySelectorAll('.fhsv2-section').forEach(initFourHands);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFourHands, { once: true });
  } else {
    initAllFourHands();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches?.('.fhsv2-section')
      ? event.target
      : event.target.querySelector?.('.fhsv2-section');

    if (root) initFourHands(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lgd-hero-banner-2"] && !Shopify.designMode) return;
  try {
    
function initHeroBanners() {
    const heroes = document.querySelectorAll(".spy-plp-conatiner .hero");
    heroes.forEach(hero => {
        if (hero.dataset.sliderInit === "1") return;

        const cards = hero.closest('.spy-plp-conatiner').querySelectorAll(".product-card");
        if (!cards.length) return;

        hero.dataset.sliderInit = "1";
        const sectionId = hero.dataset.sectionId;

        const allDesktopBgs = [];
        const allMobileBgs = [];
        cards.forEach(card => {
            if (card.dataset.bgDesktop) allDesktopBgs.push(card.dataset.bgDesktop);
            if (card.dataset.bgMobile) allMobileBgs.push(card.dataset.bgMobile);
        });

        const SLIDE_COUNT = cards.length;
        const INTERVAL_MS = parseInt(hero.dataset.rotatorSpeed) || 3000;
        let index = 0;
        let timer = null;

        const getPreloadImages = (mainOnly) => {
            const isMobile = window.innerWidth <= 991;
            if (mainOnly) {
                return isMobile ? allMobileBgs : allDesktopBgs;
            }
            return isMobile ? allDesktopBgs : allMobileBgs;
        };

        function preload(urls) {
            return Promise.all(urls.map(src => {
                const img = new Image();
                img.src = src;
                return img.decode ? img.decode().catch(() => {})
                    : new Promise(res => { img.onload = img.onerror = res; });
            }));
        }

        function render() {
            const activeCard = cards[index % cards.length];
            const isMobile = window.innerWidth <= 991;
            const customBg = isMobile ? activeCard.dataset.bgMobile : activeCard.dataset.bgDesktop;

            hero.style.backgroundImage = customBg ? `url("${customBg}")` : '';
            cards.forEach((card, i) => card.classList.toggle("active", i === index));
        }

        function next() {
            index = (index + 1) % SLIDE_COUNT;
            render();
        }

        function start() {
            if (timer) return;
            render();
            timer = setInterval(next, INTERVAL_MS);
        }

        preload(getPreloadImages(true)).then(start);
        preload(getPreloadImages(false));

        const onResize = () => render();
        window.addEventListener("resize", onResize);

        cards.forEach(function(card) {
            card.addEventListener('click', function() {
                const scroll_to_bottom = card.dataset.scrollToBottom === "true";
                if (scroll_to_bottom) {
                    const target = document.getElementById('selected-filters-slider-container');
                    if (target) {
                        const offset = 80;
                        const top = target.getBoundingClientRect().top + window.scrollY - offset;
                        window.scrollTo({ top, behavior: 'smooth' });
                    } else {
                        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                    }
                    return;
                }
                const url = card.dataset.url;
                if (url && url !== '#') {
                    window.location.href = url;
                    return;
                }
                const target = document.getElementById('selected-filters-slider-container');
                if (target) {
                    const offset = 80;
                    const top = target.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({ top, behavior: 'smooth' });
                }
            });
        });

        const onUnload = function(e) {
            if (e.detail.sectionId === sectionId) {
                clearInterval(timer);
                window.removeEventListener('resize', onResize);
                document.removeEventListener('shopify:section:unload', onUnload);
            }
        };
        document.addEventListener('shopify:section:unload', onUnload);
    });
}

if (document.readyState !== 'loading') {
    initHeroBanners();
} else {
    document.addEventListener("DOMContentLoaded", initHeroBanners);
}

document.addEventListener('shopify:section:load', function(e) {
    initHeroBanners();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lgd-hero-banner"] && !Shopify.designMode) return;
  try {
    
function initHeroBanners() {
    const heroes = document.querySelectorAll(".spy-plp-conatiner .hero");
    heroes.forEach(hero => {
        if (hero.dataset.sliderInit === "1") return;

        const cards = hero.closest('.spy-plp-conatiner').querySelectorAll(".product-card");
        if (!cards.length) return;

        hero.dataset.sliderInit = "1";
        const sectionId = hero.dataset.sectionId;

        const allDesktopBgs = [];
        const allMobileBgs = [];
        cards.forEach(card => {
            if (card.dataset.bgDesktop) allDesktopBgs.push(card.dataset.bgDesktop);
            if (card.dataset.bgMobile) allMobileBgs.push(card.dataset.bgMobile);
        });

        const SLIDE_COUNT = cards.length;
        const INTERVAL_MS = parseInt(hero.dataset.rotatorSpeed) || 3000;
        let index = 0;
        let timer = null;

        const getPreloadImages = (mainOnly) => {
            const isMobile = window.innerWidth <= 991;
            if (mainOnly) {
                return isMobile ? allMobileBgs : allDesktopBgs;
            }
            return isMobile ? allDesktopBgs : allMobileBgs;
        };

        function preload(urls) {
            return Promise.all(urls.map(src => {
                const img = new Image();
                img.src = src;
                return img.decode ? img.decode().catch(() => {})
                    : new Promise(res => { img.onload = img.onerror = res; });
            }));
        }

        function render() {
            const activeCard = cards[index % cards.length];
            const isMobile = window.innerWidth <= 991;
            if (window.innerWidth >= 768) {
              const customBg = isMobile ? activeCard.dataset.bgMobile : activeCard.dataset.bgDesktop;
              hero.style.backgroundImage = customBg ? `url("${customBg}")` : '';
            } else {
              hero.style.backgroundImage = '';
            }
            cards.forEach((card, i) => card.classList.toggle("active", i === index));
        }

        function next() {
            index = (index + 1) % SLIDE_COUNT;
            render();
        }

        function start() {
            if (timer) return;
            render();
            timer = setInterval(next, INTERVAL_MS);
        }

        preload(getPreloadImages(true)).then(start);
        preload(getPreloadImages(false));

        const onResize = () => render();
        window.addEventListener("resize", onResize);

        cards.forEach(function(card) {
            card.addEventListener('click', function() {
                const scroll_to_bottom = card.dataset.scrollToBottom === "true";
                if (scroll_to_bottom) {
 //               selected-filters-slider-container
                    const target = document.getElementById('shopify-section-template--27296164577593__main');
                    if (target) {
                        const offset = 80;
                        const top = target.getBoundingClientRect().top + window.scrollY - offset;
                        window.scrollTo({ top, behavior: 'smooth' });
                    } else {
                        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                    }
                    return;
                }
                const url = card.dataset.url;
                if (url && url !== '#') {
                    window.location.href = url;
                    return;
                }
                const target = document.getElementById('shopify-section-template--27296164577593__main');
                if (target) {
                    const offset = 80;
                    const top = target.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({ top, behavior: 'smooth' });
                }
            });
        });

        const onUnload = function(e) {
            if (e.detail.sectionId === sectionId) {
                clearInterval(timer);
                window.removeEventListener('resize', onResize);
                document.removeEventListener('shopify:section:unload', onUnload);
            }
        };
        document.addEventListener('shopify:section:unload', onUnload);
    });
}

if (document.readyState !== 'loading') {
    initHeroBanners();
} else {
    document.addEventListener("DOMContentLoaded", initHeroBanners);
}

document.addEventListener('shopify:section:load', function(e) {
    initHeroBanners();
});

(function() {
    var VIDEO_SRC = 'https://image.shoplc.com/Web/Custom_PDP/shopify-lgd-2026/v/Luxuriant-Black-vs-White-1%20(1).mp4';
    var DELAY_MS = 5000;
    var FADE_MS = 850;

    function injectVideo() {
        if (window.innerWidth > 767) return;
        var img = document.querySelector('.dynamic-mobile-video');
        if (!img || img.dataset.videoInjected) return;
        img.dataset.videoInjected = '1';

        var container = img.parentNode;
        var video = document.createElement('video');
        video.className = 'hero-bg-video';
        // Set as HTML attributes — required for Safari to honour muted + autoplay
        video.setAttribute('autoplay', '');
        video.setAttribute('muted', '');
        video.setAttribute('loop', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', ''); // older iOS Safari
        // Mirror as JS properties for other browsers
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'auto';
        video.poster = img.currentSrc || img.src;
        video.src = VIDEO_SRC;

        // Insert invisible (opacity:0) so it can buffer under the poster
        container.appendChild(video);
        video.load();

        function reveal() {
            if (video.dataset.revealed) return;
            video.dataset.revealed = '1';

            video.play().catch(function() {});

            requestAnimationFrame(function() {
                video.classList.add('is-visible');
                img.classList.add('is-fading');
            });

            setTimeout(function() {
                if (img.parentNode) img.parentNode.removeChild(img);
                video.classList.add('is-settled');
            }, FADE_MS);
        }

        function revealWhenReady() {
            if (video.readyState >= 2) {
                reveal();
                return;
            }

            var done = false;
            function finish() {
                if (done) return;
                done = true;
                reveal();
            }

            video.addEventListener('loadeddata', finish, { once: true });
            video.addEventListener('canplay', finish, { once: true });
            // Don't leave the poster stuck if media events never fire
            setTimeout(finish, 2500);
        }

        setTimeout(revealWhenReady, DELAY_MS);
    }

    if (document.readyState !== 'loading') {
        injectVideo();
    } else {
        document.addEventListener('DOMContentLoaded', injectVideo);
    }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-phased"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-view-content"]) return;
  try {
    
  // Reset Quick Add drawer transform on mobile/tablet to prevent slide-in from right (up to 1199px)
  (function() {
    if (window.innerWidth > 1199) return; // Desktop only (1200px+) - skip

    function resetDrawerTransform(dialog) {
      if (!dialog) return;
      // Force reset transform to Y-axis only on mobile/tablet (up to 1199px)
      if (window.innerWidth <= 1199) {
        dialog.style.transform = 'translateY(100%) translateX(0)';
      }
    }

    // Listen for dialog close events
    document.addEventListener('dialog:close', function(event) {
      const dialog = event.target?.closest('dialog.drawer__dialog');
      if (dialog && dialog.closest('drawer-component[id^="drawer-quick-view"]')) {
        // Reset transform after close animation completes
        setTimeout(() => {
          resetDrawerTransform(dialog);
        }, 350); // Slightly longer than animation duration
      }
    });

    // Also reset when dialog-closing class is removed
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const dialog = mutation.target;
          if (dialog instanceof HTMLDialogElement && 
              dialog.closest('drawer-component[id^="drawer-quick-view"]') &&
              !dialog.classList.contains('dialog-closing') &&
              !dialog.hasAttribute('open') &&
              window.innerWidth <= 1199) {
            resetDrawerTransform(dialog);
          }
        }
      });
    });

    // Observe all quick-view drawer dialogs
    document.querySelectorAll('drawer-component[id^="drawer-quick-view"] dialog.drawer__dialog').forEach(function(dialog) {
      observer.observe(dialog, { attributes: true, attributeFilter: ['class', 'open'] });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc_video_section"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

    const slider = document.querySelector('.LP_ugc-video-slider');
    const cards = document.querySelectorAll('.ugc-video-card');
    const prev = document.querySelector('.ugc-prev');
    const next = document.querySelector('.ugc-next');
    const dotsWrap = document.querySelector('.ugc-dots');

    if (!slider || !cards.length) return;

    /* --------------------------
        CREATE DOTS
    ---------------------------*/

    dotsWrap.innerHTML = '';

    cards.forEach((card, index) => {

        const dot = document.createElement('button');

        dot.className = 'ugc-dot';

        if(index === 0){
            dot.classList.add('active');
        }

        dot.addEventListener('click',()=>{

            card.scrollIntoView({
                behavior:'smooth',
                inline:'center',
                block:'nearest'
            });

        });

        dotsWrap.appendChild(dot);

    });

    const dots = dotsWrap.querySelectorAll('.ugc-dot');

    /* --------------------------
        UPDATE ACTIVE DOT
    ---------------------------*/

    function updateDots(){

        let active = 0;

        let closest = Infinity;

        const center =
        slider.scrollLeft +
        slider.offsetWidth/2;

        cards.forEach((card,index)=>{

            const cardCenter =
            card.offsetLeft +
            card.offsetWidth/2;

            const distance =
            Math.abs(center-cardCenter);

            if(distance < closest){

                closest = distance;

                active = index;

            }

        });

        dots.forEach(dot=>dot.classList.remove('active'));

        dots[active]?.classList.add('active');

    }

    /* --------------------------
        PAUSE OTHER VIDEOS
    ---------------------------*/

    const videos =
    slider.querySelectorAll('video');

    videos.forEach(video=>{

        video.addEventListener('play',()=>{

            videos.forEach(v=>{

                if(v!==video){

                    v.pause();

                }

            });

        });

    });

    function pauseAll(){

        videos.forEach(video=>{

            video.pause();

        });

    }

    /* --------------------------
        ARROWS
    ---------------------------*/

    next?.addEventListener('click',()=>{

        slider.scrollBy({

            left:slider.clientWidth,

            behavior:'smooth'

        });

        pauseAll();

    });

    prev?.addEventListener('click',()=>{

        slider.scrollBy({

         left:-slider.clientWidth,

            behavior:'smooth'

        });

        pauseAll();

    });

    /* --------------------------
        SCROLL
    ---------------------------*/

    slider.addEventListener('scroll',()=>{

        updateDots();

    });

    /* --------------------------
        TOUCH
    ---------------------------*/

    let startX = 0;

    slider.addEventListener('touchstart',(e)=>{

        startX = e.touches[0].clientX;

    });

    slider.addEventListener('touchend',(e)=>{

        const endX = e.changedTouches[0].clientX;

        if(Math.abs(startX-endX)>60){

            updateDots();

        }

    });

    updateDots();

});


  } catch(e) { console.error(e); }
})();
})();
